import { render } from "./RoomsTab.vue?vue&type=template&id=5bfb8c7e&scoped=true&ts=true"
import script from "./RoomsTab.vue?vue&type=script&lang=ts"
export * from "./RoomsTab.vue?vue&type=script&lang=ts"

import "./RoomsTab.vue?vue&type=style&index=0&id=5bfb8c7e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bfb8c7e"]])

export default __exports__